import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb.js';
import { RegisteredToOptions } from '@/lib/routing.js';
import { Link } from '@tanstack/react-router';
import { Fragment } from 'react';

export interface PageBreadcrumbProps {
  linkItems: Array<{
    label: string;
    link: RegisteredToOptions;
  }>;
  currentPage: string;
  'data-testid'?: string;
}

export const PageBreadcrumb = ({ linkItems, currentPage, 'data-testid': dataTestId }: PageBreadcrumbProps) => {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {linkItems.map(({ label, link }, index) => (
          <Fragment key={`breadcrumb-${label}-${index}`}>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link {...link} data-testid={dataTestId ? `${dataTestId}-link-${index + 1}` : undefined}>
                  {label}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
          </Fragment>
        ))}
        <BreadcrumbItem>
          <BreadcrumbPage data-testid={dataTestId ? `${dataTestId}-current` : undefined}>{currentPage}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};
